import buco from '../images/buco.png'

function Buco() {
	return (
		<center>
		<img src={buco} alt="buco"/>
		</center>
	)
}

export default Buco;

